import { createStore } from 'vuex'

const MEMBER = "MEMBER";

export default createStore({
  state: {
    // 增加 typeof window 判断，提升代码健壮性
    member : (typeof window !== 'undefined' && window.SessionStorage)
        ? (window.SessionStorage.get(MEMBER) || {})
        : {},
    isMobile: false // <--- 【核心修复】：加上手机端全局标识
  },
  getters: {},
  mutations: {
    setMember (state, member) {
      state.member = member
      if (typeof window !== 'undefined' && window.SessionStorage) {
        window.SessionStorage.set(MEMBER, member)
      }
    },
    setIsMobile(state, status) { // <--- 【核心修复】：加上更新状态的方法
      state.isMobile = status
    }
  },
  actions: {},
  modules: {}
})